export enum EPageType {
  M12y25smb = 'm12y25smb',
  M12y25ab = 'm12y25ab',
  M12y25sob = 'm12y25sob',
  M12y25perDay = 'm12y25perDay',
  M03y26smb = 'm03y26smb',
  M03y26ab = 'm03y26ab',
  M03y26sob = 'm03y26sob',
  WithRangeM03y26 = 'withRangeM03y26',
}
